import React from 'react';
import ProgramSuggestionItem from './ProgramSuggestionItem';
import { programTag } from './tag';
import {
  makeCriteriaProvider,
  makeEnhancedPMCriteriaProvider
} from './enhancers';
import ProgramFacetDetails from './ProgramFacetDetails';

export const EnhancedPMProgramFacet = {
  tag: programTag,
  makeCriteriaProvider: makeEnhancedPMCriteriaProvider,
  DetailsControl: (props = {}) => (
    <ProgramFacetDetails
      {...props}
      usePageOfProgramsAvailableForFilteringResourceUsersQuery
    />
  ),
  SuggestionItem: ProgramSuggestionItem
};

export default {
  tag: programTag,
  makeCriteriaProvider,
  DetailsControl: ProgramFacetDetails,
  SuggestionItem: ProgramSuggestionItem
};
